import axios from 'axios'
import { castAttributesForCamelCase } from '../../../modules/string_converter'
import {
  setFormValues,
  setFilterValues,
  toggleFilterValues,
} from '../../../modules/mutations.js'

export const companiesCustomSurveyAnswers = {
  namespaced: true,
  state: {
    questions: [],
    answers: [],
    meta: null,
    surveyLoading: false,
    loading: false,
    formValues: {},
    filteredCount: 0,
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    readSurveyAnswersSuccess(state, payload) {
      state.questions = payload.data.questions.map(q => castAttributesForCamelCase(q))
      state.answers = payload.data.answers.map(a => castAttributesForCamelCase(a))
      state.meta = castAttributesForCamelCase(payload.meta)
      state.loading = false
    },
    readSurveyAnswersFailure(state) {
      state.loading = false
    },
    deleteSurveyAnswersSuccess(state, id) {
      state.answers = state.answers.filter(answer => answer.id != id)
      state.loading = false
    },
    deleteSurveyAnswersFailure(state) {
      state.loading = false
    },
    setValuesForFilter(state, payload) {
      state.filteredCount = payload.meta.total_count
    },
    exportCsvSuccess(state){
      state.loading = false
    },
    exportCsvFailure(state){
      state.loading = false
    },
    setFormValues,
    setFilterValues,
    toggleFilterValues,
  },
  actions: {
    readCustomSurveyAnswers({ commit, rootState }, payload) {
      commit('prepareConnect')
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/custom_surveys/answers.json', payload.values)
        .then(res => {
          commit('readSurveyAnswersSuccess', res.data)
          commit('setValuesForFilter', res.data)
        })
        .catch(err => {
          commit('readSurveyAnswersFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    readCustomSurveyAnswersForFilter({ commit, rootState }, payload) {
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/custom_surveys/answers.json', payload.values)
        .then(res => {
          commit('setValuesForFilter', res.data)
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    deleteCustomSurveyAnswer({ commit, rootState }, id) {
      commit('prepareConnect')
      return axios
        .delete('/api/companies/' + rootState.route.params.company_uuid + '/custom_surveys/answers/' + id)
        .then(() => {
          commit('deleteSurveyAnswersSuccess', id)
        })
        .catch(err => {
          commit('deleteSurveyAnswersFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    exportCsv({ commit, rootState }, payload) {
      commit('prepareConnect')
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/export/custom_surveys/answers.json', payload.values)
        .then(() => {
          commit('exportCsvSuccess')
          return true
        })
        .catch(err => {
          commit('exportCsvFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
  }
}
